var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.058,
    height: 10.872,
    viewBox: "0 0 16.058 10.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-email-1042992",
    transform: "translate(-4.75 -19.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(5 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M6.556,972.362A1.564,1.564,0,0,0,5,973.918v7.26a1.564,1.564,0,0,0,1.556,1.556H19a1.564,1.564,0,0,0,1.556-1.556v-7.26A1.564,1.564,0,0,0,19,972.362H6.556Zm0,1.037H19a.506.506,0,0,1,.519.519v7.26A.507.507,0,0,1,19,981.7H6.556a.506.506,0,0,1-.519-.519v-7.26a.506.506,0,0,1,.519-.519Zm11.609,1.026a.519.519,0,0,0-.33.141l-4.673,4.214a.565.565,0,0,1-.778,0l-4.662-4.214a.52.52,0,1,0-.7.772l2.5,2.253-2.485,2.155a.519.519,0,1,0,.681.783l2.582-2.242,1.394,1.259a1.618,1.618,0,0,0,2.161,0l1.4-1.264,2.588,2.247a.519.519,0,1,0,.681-.783l-2.49-2.161,2.5-2.247a.519.519,0,0,0-.362-.913Z",
    transform: "translate(-5 -972.362)",
    fill: "#fff",
    stroke: "#253845",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.0dccb97d58177f2a9d73e3ad644deb13.svg";
export { ForwardRef as ReactComponent };